import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { GetListMessagePatientCenterResponse } from '../../responses/notification/get-list-message-patient-center.response';

@Injectable({
  providedIn: 'root'
})
export class MessagePatientCenterService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public listNotificationByUser(timeZoneValue: number): Observable<GetListMessagePatientCenterResponse> {
    
    let uri = `MessagePatientCenterPatientAuthorized/getAllByTokenIdUserPatient/timeZoneValue/${timeZoneValue}`;
    
    return this.httpClient.get<GetListMessagePatientCenterResponse>(environment.urlApiNotification + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public markAllNotificationRead(): Observable<ReturnStruct> {
    
    let uri = `MessagePatientCenterPatientAuthorized/markAllIsReadByUser`;
    
    return this.httpClient.put<ReturnStruct>(environment.urlApiNotification + uri, null, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public markNotificationRead(idUserMessagePatientCenter: number): Observable<ReturnStruct> {
    
    let uri = `MessagePatientCenterPatientAuthorized/markIsRead/idUserMessagePatientCenter/${idUserMessagePatientCenter}`;
    
    return this.httpClient.put<ReturnStruct>(environment.urlApiNotification + uri, null, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public deleteAllNotification(): Observable<ReturnStruct> {
    
    let uri = `MessagePatientCenterPatientAuthorized/deleteAll`;
    
    return this.httpClient.delete<ReturnStruct>(environment.urlApiNotification + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public deleteNotification(idUserMessagePatientCenter: number): Observable<ReturnStruct> {
    
    let uri = `MessagePatientCenterPatientAuthorized/idUserMessagePatientCenter/${idUserMessagePatientCenter}`;
    
    return this.httpClient.delete<ReturnStruct>(environment.urlApiNotification + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
